import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ButtonBuiltInControl} from '../ButtonBuiltInControl';

/**
 * @description base class including background color modifications logic
 */
export abstract class ButtonBackgroundColorBuiltInControl extends ButtonBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes.GENERAL.BACKGROUND_COLOR;
  }
}
